'use client';

/**
 * Calculate spacing number of bar
 * @param chartWidth Total chart width in pixel
 * @param barWidth bar width in pixel
 * @param totalBars total Bars count
 * @param currentIndex current bar index
 * @returns number of spacing base on index of bar
 */
var calculateBarSpacing = function (chartWidth, barWidth, totalBars, currentIndex, xAxisPosition, isHorizontal) {
    if (isHorizontal === void 0) { isHorizontal = false; }
    // total chartWidth (32 Left spacing of X Axis to charts and minus Right spacing of X Axis)
    var displayWidth = chartWidth;
    if (!isHorizontal) {
        displayWidth -= 54;
        if (xAxisPosition === 'end') {
            displayWidth -= 40;
        }
    }
    var totalBarWidth = totalBars * barWidth;
    // Do not include last bar because we don't need right spacing of last bar
    var remainSpacing = (displayWidth - totalBarWidth) / (totalBars - 1);
    return remainSpacing * currentIndex;
};

export { calculateBarSpacing };
//# sourceMappingURL=helpers.js.map
